import axios, {AxiosResponse} from "axios";
import {
    Node as SomatNode,
    NodeType,
    SurveySession, SurveySessionNodeProgress,
    SurveySessionProgressSummary
} from "@/types/models";
export const getChildren = async (node: SomatNode, session?: SurveySession) => {
    return await axios
        .get(route("api.session.children", {
            node: node,
            session: session?.id,
        }))
        .then((response: AxiosResponse<SomatNode[]>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const loadNodePath = async (nodeId: number, session?: SurveySession) => {
    return await axios
        .get(route("api.session.node-path", {
            node: nodeId,
            session: session?.id,
        }))
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const createArrayNode = async(node: SomatNode, session: SurveySession) => {
    return await axios
        .post(route("api.session.array-node.add", {
            node: node,
            session: session?.id,
        }))
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const deleteArrayNode = async(node: SomatNode, session: SurveySession) => {
    return await axios
        .delete(route("api.session.array-node.delete", {
            node: node,
            session: session?.id,
        }))
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const getNodeTypes = async(session: SurveySession) => {
    return await axios
        .get(route("api.session.node-types", {
            session: session?.id,
        }))
        .then((response: AxiosResponse<NodeType[]>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const getProgressSummary = async(session: SurveySession) => {
    return await axios
        .get(route("api.session.progress", {
            session: session?.id
        }))
        .then((response: AxiosResponse<SurveySessionProgressSummary>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const getProgressDetail = async(session: SurveySession, node?: SomatNode) => {
    const args: { session: number, detail: boolean, node?: number} = {
        session: session.id,
        detail: true
    }
    if(node) args.node = node.id
    return await axios
        .get(route("api.session.progress", args))
        .then((response: AxiosResponse<SurveySessionNodeProgress>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const flattenHierarchy = (nodes: SomatNode[]): SomatNode[] => {
    return nodes.reduce((acc: SomatNode[], node: SomatNode) => {
        if(node.children) return acc.concat(node, flattenHierarchy(node.children))
        return acc.concat(node)
    }, [])
}


export const createNode = async(data: Omit<SomatNode, 'id'>) => {
    return await axios
        .post(route("api.node.create"), data)
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const updateNode = async(node: SomatNode) => {
    const { parent, children, content, ...data} = node
    return await axios
        .put(route("api.node.update"), data)
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const moveNode = async(node: SomatNode, relation: SomatNode, relationship: 'child' | 'sibling') => {
    const args = {
        id: node.id,
        relation_id: relation.id,
        relationship: relationship
    }
    return await axios
        .put(route("api.node.move"), args)
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const deleteNode = async(node: SomatNode) => {
    return await axios
        .delete(route("api.node.delete", {node: node.id}))
        .then((response: AxiosResponse<SomatNode>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}
